// extracted by mini-css-extract-plugin
export var accordionBody = "style-mod--accordion-body--a5ce2";
export var accordionCard = "style-mod--accordion-card--789c8";
export var accordionIcon = "style-mod--accordion-icon--d80e6";
export var accordionIconOpen = "style-mod--accordion-icon-open--4a012";
export var accordionTitle = "style-mod--accordion-title--abf27";
export var cardHeader = "style-mod--card-header--643fc";
export var clipStar = "style-mod--clip-star--a3b09";
export var content = "style-mod--content--3bc7f";
export var productDetailsAccordion = "style-mod--product-details-accordion--cd511";
export var rating = "style-mod--rating--860bc";
export var ratingDesc = "style-mod--rating-desc--90773";